// *消息类型
export enum EMessageType {
    /// <summary>
    /// 系统消息
    /// </summary>
    SystemMessage = 0,
    /// <summary>
    /// 系统广播
    /// </summary>
    SystemBroadcast = 1,
    /// <summary>
    /// 工作流
    /// </summary>
    Workflow = 10,
    /// <summary>
    /// 工作流抄送
    /// </summary>
    WorkflowCopy = 11,
    /// <summary>
    /// 授权相关
    /// </summary>
    Permission = 20,
    /// <summary>
    /// 报表
    /// </summary>
    Report = 30,
    /// <summary>
    /// 其他
    /// </summary>
    Other = 100,
}